/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_X15_Check_FailedInputs */



/**
* | output |
* | --- |
* | "The security check did not pass. Complete the Cloudflare check on this page, then try again." |
*
* @param {Auth_X15_Check_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_x15_check_failed = /** @type {((inputs?: Auth_X15_Check_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_X15_Check_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("The security check did not pass. Complete the Cloudflare check on this page, then try again.")
});